// extracted by mini-css-extract-plugin
module.exports = {"bar_bg":"PeopleBar_bar_bg__3fDBk","people_bar_btn":"PeopleBar_people_bar_btn__2miIy"};